import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';
import { useTranslation } from 'react-i18next';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');

export type MobilePayType = {
  mobilePaySystem: string;
};

export const MobilePay: CustomFC<MobilePayType> = ({ mobilePaySystem }) => {
  const { t } = useTranslation();
  const title = { google: 'Google Pay', apple: 'Apple Pay', samsung: 'Samsung Pay' }[
    mobilePaySystem
  ];

  return <div className={cn('mobile-pay')}>{`${t('transactions.by')} ${title}`}</div>;
};

export default MobilePay;
